const input = {
    username: 'Utilizador',
    password: 'Palavra-passe',
    email: 'Email',
    phone_number: 'Telefone',
    confirm_password: 'Confirmar palavra-passe',
    search_region_code: 'Procurar código de região',
    backup_code: 'Código de backup',
    label_with_optional: '{{label}} (Opcional)',
};
export default Object.freeze(input);
